import React,{useState,useEffect, useContext}  from 'react';
import { useNavigate} from 'react-router-dom';
import { FiExternalLink,FiPlusSquare } from 'react-icons/fi';
import TextLink from 'components/UI/TextLink/TextLink';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import GridCard from '../GridCard/GridCard';

import {loadState} from 'library/helpers/localStorage' ; 
import { Modal } from 'antd';
import ModalDetailRoom from 'containers/SinglePage/DetailRoom/ModalDetailRoom';
import { getPrixPromo,infoPromo, getOffrePeriode, isSejourInPeriodeDeOffre } from 'library/helpers/fonction';
import { SharedDataContext } from 'context/SharedDataProvider';
import moment from 'moment';
import Heading from 'components/UI/Heading/Heading';

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024,
    },
    items: 1,
    paritialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0,
    },
    items: 1,
    paritialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464,
    },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};

const GridRoom = ({
  title,
  location,
  price,
  link,
  nomChambre,
  id,
  typeHebergement,
  prixEuro,
  prixAriary,
  currency,
  images,
  hotel,
  offre,
  remiseValue,
  prixDayUseAriary,
  prixDayUseEuro,
  dateSejour,
  loadTarif
}) => {
  let navigate = useNavigate();
  const [linkTo, setLinkTo] = useState('');
  const [isRemise, setIsRemise] = useState(false);
  /** for the day use check */
  const {
    isFiltreDayUseChecked, 
    filtreDayUseDate,
  } = useContext(SharedDataContext);

  let prix = 0;
    
  if (isFiltreDayUseChecked) {
    prix = currency == "€" ? prixDayUseEuro ?? 0 : prixDayUseAriary ?? 0;
  } else {
    prix = currency == "€" ? prixEuro: prixAriary;
  }

  let priceSansPromo = remiseValue ? prix : null ; 
  if (!isFiltreDayUseChecked) {
    prix = remiseValue ? getPrixPromo(prix,remiseValue) : prix; //remiseValue  ? prix - (prix * remiseValue / 100) : null; 
  }

  useEffect(()=>{
    if(dateSejour?.setStartDate !==null 
      && dateSejour?.setStartDate !== undefined) {
        let d = (dateSejour?.setStartDate)?.split('-');
        let f = (dateSejour?.setEndDate)?.split('-');
        let debutSejour = moment(`${d[2]}-${d[1]}-${d[0]}`);
        let finSejour = moment(`${f[2]}-${f[1]}-${f[0]}`);
        let offreJP = getOffrePeriode(debutSejour,finSejour, offre) ;
        let isRemise = isSejourInPeriodeDeOffre(debutSejour,finSejour,offreJP)
        setIsRemise(isRemise);
    }
  },[dateSejour])

  const descriptionOffre = infoPromo(offre) ;
   // window.history.pushState(offre, null, linkTo);

  const error = (message, callbackFn) => {
    Modal.error({
      title: 'Réservation',
      content: message,
      onOk() {
        if (callbackFn) {
          callbackFn();
        }
        return;
      }
    });
  };

  
  const showModalMaintenance = () => {
    Modal.info({
      title: 'Maintenance en cours',
      content: 'La partie paiement de la réservation est actuellement en maintenance. Nous travaillons activement pour ouvrir ce service très prochainement. Merci de votre compréhension et de votre patience.',
    });
  };

  const showModal = () => {
      if(process.env.REACT_APP_MAINTENANCE_ACTIVE && process.env.REACT_APP_MAINTENANCE_ACTIVE == 1) 
      {
        showModalMaintenance();
      }
      else{
        const param = loadState("filtre");
        const user = loadState("user");
        if (user && user.profil != 'CLIENT'){
          error(`Veuillez vous connecter en tant que client afin de procéder à une réservation, s'il vous plaît.`);
          return ; 
        }
        if ((isFiltreDayUseChecked && filtreDayUseDate) || ( !isFiltreDayUseChecked && param && param.date_range.setStartDate && param.date_range.setEndDate)){
          setLinkTo(`${link}/${id}`);
          // window.history.pushState(offre, null, linkTo);
          window.location.href(linkTo);
        }else{
          error(
            'Pour réserver, merci de saisir' + (isFiltreDayUseChecked ? ' la date' : ' les dates' )+ ' et chercher la disponibilité'
            , ()=> {
            //scroll vers le champ de recherche date
            document.querySelector('#linkItem_room').click();
            document.querySelector('.DateInput_input_1').focus();
          });
        }
    } 
  };
  
  return (
    <GridCard
      loadTarif={loadTarif}
      isCarousel={true}
      // location={location.formattedAddress}
      currency={currency}
      title={<Heading as="h4" content={`${nomChambre}`} style={{ color: '#2C2C2C' }}/>}
      price={prix}//{<MoneyFormat value={`${prix}`} suffix={` ${currency}`}/>}
      priceSansPromo={priceSansPromo}
      remiseValue={remiseValue}
      isRemise={isRemise}
      descriptionOffre={descriptionOffre}
      offre={offre}
      id={id}
      // info={
      //   information.equipement.map((item) => (
      //     <li key={item.label}  >
      //     {item.icon}&nbsp;&nbsp;
      //       <span>{item.label}</span>&nbsp;&nbsp;&nbsp;&nbsp;
      //     </li>
      //   ))
      // }
      detailsBtn={
        <ModalDetailRoom
          icon={<FiExternalLink />}
          style={{ color: 'rgb(40 ,177, 89)' }}
          libelle="Détails"
          images={images}
          hotel={hotel}
          id={id}
          dayUseParams= {{
            isDayUse: isFiltreDayUseChecked,
            prixDayUseAriary,
            prixDayUseEuro
          }}
        />
      }

      viewDetailsBtn={
        <TextLink
        link={linkTo}
        icon={<FiPlusSquare />}
        onClick={showModal}
        customProp={offre}
        style={{ color: 'rgb(40 ,177, 89)' }}
          content="Réserver"
        />
      }
    >
      <Carousel
        additionalTransfrom={0}
        arrows
        autoPlaySpeed={3000}
        containerClass="container"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        renderDotsOutside={false}
        responsive={responsive}
        showDots={true}
        sliderClass=""
        slidesToSlide={1}
      >
        {images.map(({ url, name }, index) => (
          <img
            src={`${process.env.REACT_APP_API_URL}/${url}`}
            alt={name}
            key={index}
            draggable={false}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'relative',
            }}
          />
        ))}
      </Carousel>
    </GridCard>
    
  );
};

export default GridRoom;
